const testimonials = [
  {
    name: 'Michael Rodriguez',
    position: 'Property Manager',
    company: 'Downtown Commercial Plaza',
    content: 'American Guard Services has been protecting our commercial property for over 5 years. Their professionalism and attention to detail are unmatched. We feel completely secure knowing they are on duty.',
    rating: 5,
  },
  {
    name: 'Sarah Thompson',
    position: 'Event Coordinator',
    company: 'Premier Events Group',
    content: 'We have worked with AGS for numerous large-scale events. Their team is always prepared, professional, and handles every situation with expertise. They are our go-to security partner.',
    rating: 5,
  },
  {
    name: 'David Chen',
    position: 'Operations Director',
    company: 'Pacific Retail Corporation',
    content: 'The loss prevention services provided by American Guard Services have significantly reduced shrinkage at our retail locations. Their strategic approach and trained personnel deliver real results.',
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-dark-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">
            Client Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mt-4 mb-6 font-display">
            Trusted By Industry Leaders
          </h2>
          <p className="text-dark-600 text-lg max-w-3xl mx-auto">
            See what our clients have to say about our professional security services and commitment to excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-lg transition-shadow border border-dark-200"
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-500 text-lg"></i>
                ))}
              </div>
              <p className="text-dark-700 text-sm mb-6 leading-relaxed italic">
                "{testimonial.content}"
              </p>
              <div className="border-t border-dark-200 pt-4">
                <div className="font-semibold text-dark-900">{testimonial.name}</div>
                <div className="text-dark-600 text-sm">{testimonial.position}</div>
                <div className="text-primary-600 text-sm font-medium">{testimonial.company}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-8 bg-white rounded-lg px-8 py-6 shadow-sm border border-dark-200">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-600">4.9/5</div>
              <div className="text-dark-600 text-sm">Client Rating</div>
            </div>
            <div className="h-12 w-px bg-dark-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-600">500+</div>
              <div className="text-dark-600 text-sm">Satisfied Clients</div>
            </div>
            <div className="h-12 w-px bg-dark-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-600">98%</div>
              <div className="text-dark-600 text-sm">Retention Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;